import React, { Component } from 'react';
import classnames from 'classnames';

class DialogButton extends Component {
  render () {
    const { primary, onClick, children } = this.props;
    return (
      <div className="mce-widget mce-btn mce-flow-layout-item mce-btn-has-text" tabIndex="-1" role="button">
        <button role="presentation" type="button" className={classnames({ 'btn-primary': primary })} tabIndex="-1" onClick={onClick}>
          <span className="mce-txt">{children}</span>
        </button>
      </div>
    );
  }
}

export default DialogButton;
